import PocketBase from 'pocketbase';

export const pb = new PocketBase('https://api.snapdiet.app');

